import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tree-part-horizontal',
  templateUrl: './tree-part-horizontal.component.html'
})
export class TreePartHorizontalComponent {
  @Input() data: any;
  @Input() indexNumber: any = 0;
  public randomNumber:number = Math.floor(Math.random() * 100);
}
